import { useNavigate } from 'react-router-dom';

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Creative%20editorial%20flat%20lay%20composition%20featuring%20a%20diverse%20collection%20of%20fashion%20items%20including%20sneakers%20a%20beige%20hoodie%20gold%20accessories%20and%20a%20brown%20leather%20bag%20arranged%20artistically%20on%20a%20warm%20terracotta%20textured%20surface%2C%20with%20a%20clean%20modern%20tablet%20displaying%20a%20minimalist%20spreadsheet%20interface%20positioned%20in%20the%20center%2C%20soft%20diffused%20morning%20light%20from%20a%20large%20window%20on%20the%20left%20side%20creating%20long%20gentle%20shadows%2C%20warm%20earthy%20color%20palette%20with%20pops%20of%20deep%20green%20from%20a%20small%20potted%20succulent%20accent%2C%20sophisticated%20lifestyle%20blogger%20aesthetic%20with%20intentional%20negative%20space%20around%20the%20edges&width=1600&height=900&seq=hero-v2-css-2026&orientation=landscape"
          alt="CSSBuy Spreadsheet - Fashion product curation"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></span>
              <span className="text-xs font-medium text-background-50/90 tracking-wide whitespace-nowrap">
                2026 Verified Database — Updated Daily
              </span>
            </div>

            {/* Headline */}
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight mb-6">
              CSSBuy Spreadsheet <br />
              <span className="text-accent-300 italic">Verified QC Database</span>
              <br />&amp; Best Finds
            </h1>

            <p className="text-base md:text-lg text-background-50/80 leading-relaxed mb-8 max-w-lg">
              Your go-to resource for curated CSSBuy product spreadsheets. Explore sneakers, luxury items, streetwear, and trending finds — all verified by a community of experienced buyers.
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-start gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                CSSBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold text-foreground-950 bg-background-50 hover:bg-background-100 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Buy It Now
                <i className="ri-shopping-cart-line"></i>
              </a>
              <button
                onClick={() => {
                  navigate('/cssbuy-spreadsheet-guide');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-7 py-3 text-sm font-medium text-background-50 border border-background-50/40 hover:bg-background-50/10 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Read the Guide
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 rounded-full border-2 border-background-50/30 flex items-start justify-center p-1.5">
          <div className="w-1.5 h-3 rounded-full bg-background-50/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}